import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import bemClass from './../../../utils/bemClass'

import './Socials.css'

const cn = bemClass('Socials')

class Item extends PureComponent {
    render() {
        const { Component, href, title } = this.props
 
        return (
            <a target="_blank" href={href} title={title} className={cn('item')}>
                <Component className={cn('icon')} />
            </a>
        )
    }
}

Item.propTypes = {
    Component: PropTypes.func,
    title: PropTypes.string,
    href: PropTypes.string,
}

export default Item


// WEBPACK FOOTER //
// ./src/components/Header/Socials/Item.jsx